import { IDefineCommand, IQuery } from 'core-ts-types';
import { RegistrationReceiptModel } from '../models/registration_reciept_model';

export type ClearRegistrationRecieptCommand = () => ng.IPromise<IQuery[]>;

angular
  .module('capability-ng-scheduler')
  .factory(
    'clearRegistrationRecieptCommand',
    (defineCommandORM: IDefineCommand, ngRegistrationReceiptModel: RegistrationReceiptModel) =>
      defineCommandORM('clearRegistrationRecieptCommand', (deferred) => {
        ngRegistrationReceiptModel.clear();
        deferred.resolve();
      })
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/registration_receipt/commands/clear_registration_reciept_command.ts